import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJHistory from '../view/FJHistory.jsx';
import { useSelector, useDispatch } from 'react-redux';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJSelectAll from '../../../../common/components/FJSelectAll/FJSelectAll.jsx';
import FJActionCommon from '../../../../redux/action/FJActionCommon.js';
import FJAudioPlayManager from '../../../../store/FJAudioPlayManager.js';
import { setSliceSelectListAction } from '../../../../redux/slices/FJSliceCommon.js';
import FJConstant from '../../../../constants/FJConstant.js';
import FJKeymap from '../../../../util/FJKeymap.js';
import { useEffect, useCallback } from 'react';

const FJHistoryContainer = () => {
    const dispatch = useDispatch();
    useLocalStore();
    const projectList = useSelector(state => state.textToSpeech.projectList);
    const appType = useSelector(state => state.common.appType);
    const selectList = useSelector(state => state.common.selectList);
    const isMultipleMode = useSelector(state => state.common.isMultipleMode);

    const setIsMultipleMode = bool => {
        dispatch(FJActionCommon.setIsMultipleModeAction(bool));
        FJAudioPlayManager.pauseAll();
    };

    const _clearSelected = () => {
        setIsMultipleMode(false);
    };

    const _setSliceSelectList = value => {
        dispatch(setSliceSelectListAction(value));
    };

    const _multiDelete = ids => {
        dispatch(FJActionCommon.multiDeleteAction(ids, undefined, { type: FJConstant.TEXT_TO_SPEECH }));
    };

    const _keyDown = useCallback(
        e => {
            if (e.code === 'Escape') {
                if (FJKeymap.getScope() === 'default') {
                    _setSliceSelectList([]);
                    setIsMultipleMode(false);
                }
            }
        },
        [_setSliceSelectList],
    );

    useEffect(() => {
        window.addEventListener('keydown', _keyDown);
        return () => {
            window.removeEventListener('keydown', _keyDown);
        };
        //TODO 业务需要此依赖
    }, [_keyDown, isMultipleMode]);

    return (
        <FJHistory list={projectList}>
            <FJSelectAll
                appType={appType}
                list={projectList}
                selectList={selectList}
                setSelectList={_setSliceSelectList}
                multiDelete={_multiDelete}
                isMultipleMode={isMultipleMode}
                clearSelected={_clearSelected}
                isShowAddToMediaButton={window.isEditPage}
                selectedText={FJLocalStore._(selectList.length < 2 ? 'project-selected' : 'projects-selected')}
                hideDownload={true}
            />
        </FJHistory>
    );
};
export default FJHistoryContainer;
